import { Component, ChangeDetectionStrategy } from "@angular/core";
import { environment } from "../../../environments/environment";
import { RouteDataService } from "../../services/route-data/route-data.service";

@Component({
  selector: "app-navigation-questionnaire",
  templateUrl: "./navigation-questionnaire.component.html",
  styleUrls: ["./navigation-questionnaire.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationQuestionnaireComponent {
  env: any = environment;

  constructor(public routeData: RouteDataService) {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/navigation-questionnaire/navigation-questionnaire.component.ts